import { createCsrfMiddleware, createStart } from "@tanstack/react-start";
import { sessionRequestMiddleware } from "@/api/middleware/auth";
import { safeErrorFunctionMiddleware } from "@/api/middleware/safe-error";
import {
  bffUserFacingErrorSerializationAdapter,
  unauthorizedErrorSerializationAdapter,
} from "@/lib/errors";

// Defense-in-depth against CSRF on our same-origin RPC endpoints. The session
// cookie is SameSite=Lax (see server/use-cases/auth/cookies.ts), which blocks
// the primary cross-site POST vector, but not GET-capable server functions and
// not a future flip to SameSite=None. This validates Origin / Sec-Fetch-Site /
// Referer at the RPC boundary and returns 403 on mismatch. Ordered before
// sessionRequestMiddleware so cross-origin requests are rejected before any
// session/DB work.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => {
  return {
    requestMiddleware: [csrfMiddleware, sessionRequestMiddleware],
    // The scrub middleware wraps every server-function middleware chain and
    // handler, so no error path can reach the client unscrubbed. Server
    // functions that need the session compose sessionRequestMiddleware
    // themselves (see api/middleware/auth.ts) — Start dedupes it against the
    // request-layer run above.
    functionMiddleware: [safeErrorFunctionMiddleware],
    // Round-trip our user-facing error classes across SSR/RPC serialization
    // so the client keeps the class and tag (see lib/errors.ts).
    serializationAdapters: [
      unauthorizedErrorSerializationAdapter,
      bffUserFacingErrorSerializationAdapter,
    ],
  };
});
